import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthSliceState {
    accessToken?: string;
    permissions: string[];
}

const initialState: AuthSliceState = {
    accessToken: undefined,
    permissions: [],
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken(
            state,
            action: PayloadAction<{ accessToken: string; permissions: string[] }>,
        ) {
            const { accessToken, permissions } = action.payload;
            return { ...state, accessToken, permissions };
        },
    },
});

export const { setAccessToken } = authSlice.actions;
